import { render, staticRenderFns } from "./AdminMorebbs.vue?vue&type=template&id=47f1d291&"
import script from "./AdminMorebbs.vue?vue&type=script&lang=js&"
export * from "./AdminMorebbs.vue?vue&type=script&lang=js&"
import style0 from "./AdminMorebbs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports